(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["siwl107-restock-notice"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('siwl107-restock-notice')) {
    customElements.define('siwl107-restock-notice', class extends HTMLElement {
      connectedCallback() {
        if (this.initialized) return;
        this.initialized = true;
        this.dialog = this.querySelector('dialog');
        this.cta = this.querySelector('[data-restock-request]');
        this.status = this.querySelector('[data-restock-status]');
        this.formDialog = this.querySelector('[data-restock-form-dialog]');
        this.cursor = document.getElementById('custom-gif-cursor');
        this.cursorMedia = matchMedia('(min-width: 769px) and (pointer: fine)');
        this.cursorAttributes = ['popover', 'aria-hidden'].map(name => [name, this.cursor?.getAttribute(name)]);
        this.syncCursor = () => {
          const activeDialog = [this.dialog, this.formDialog].find(dialog => dialog.open);
          if (!activeDialog || !this.cursorMedia.matches || !this.cursor?.showPopover || !this.cursor.complete || !this.cursor.naturalWidth) {
            this.restoreCursor();
            return;
          }
          if (this.cursorDialog === activeDialog && this.cursor.matches(':popover-open')) return;
          try {
            if (this.cursor.matches(':popover-open')) this.cursor.hidePopover();
            this.cursor.setAttribute('popover', 'manual');
            this.cursor.setAttribute('aria-hidden', 'true');
            this.cursor.setAttribute('data-restock-top-layer', '');
            this.cursor.showPopover();
            this.cursorDialog = activeDialog;
          } catch {
            this.restoreCursor();
          }
        };
        this.cursorObserver = new MutationObserver(this.syncCursor);
        this.cursorObserver.observe(this, { subtree: true, attributes: true, attributeFilter: ['open'] });
        this.cursorMedia.addEventListener('change', this.syncCursor);
        this.cursor?.addEventListener('load', this.syncCursor);
        this.querySelector('[data-restock-form-close]').addEventListener('click', () => this.formDialog.close());
        this.formDialog.addEventListener('close', () => this.reopenButton?.focus());
        this.variants = JSON.parse(this.querySelector('[data-restock-variants]').textContent);
        this.seen = new Set();
        this.querySelectorAll('[data-restock-close]').forEach(button => button.addEventListener('click', () => this.dialog.close()));
        this.dialog.addEventListener('click', event => {
          if (event.target !== this.dialog) return;
          const box = this.dialog.getBoundingClientRect();
          if (event.clientX < box.left || event.clientX > box.right || event.clientY < box.top || event.clientY > box.bottom) this.dialog.close();
        });
        this.cta.addEventListener('click', () => {
          const button = this.nativeButton();
          if (!button) { this.cta.disabled = true; this.status.textContent = this.status.dataset.unavailable; return; }
          this.dialog.close();
          button.scrollIntoView({ block: 'center', behavior: 'instant' });
          button.focus();
          button.click();
        });
        this.presentNativeForm = () => {
            const wrapper = document.querySelector('.sendvio_back_in_stock_wrapper');
            const form = wrapper?.querySelector('[data-section="form"]');
            if (!form || this.formDialog.contains(wrapper) || !form.getClientRects().length) return;
            if (!this.formDialog.contains(wrapper)) {
              this.reopenButton = document.createElement('button');
              this.reopenButton.type = 'button';
              this.reopenButton.className = 'siwl107-restock-notice__primary';
              this.reopenButton.textContent = this.cta.textContent;
              wrapper.before(this.reopenButton);
              this.reopenButton.addEventListener('click', () => this.formDialog.showModal());
              this.querySelector('[data-restock-form-host]').append(wrapper);
            }
            if (!this.formDialog.open) this.formDialog.showModal();
            const email = form.querySelector('input[name="email"]');
            if (email) { email.type = 'email'; email.autocomplete = 'email'; email.setAttribute('aria-label', email.getAttribute('placeholder') || 'Email'); email.focus(); }
        };
        this.onNativeClick = event => {
          if (event.target.closest('.sndv_bkstk_notify_btn')) setTimeout(this.presentNativeForm, 0);
        };
        document.addEventListener('click', this.onNativeClick, true);
        this.check = () => {
          const variantId = new URL(location.href).searchParams.get('variant') || this.dataset.initialVariant;
          const variant = this.variants.find(item => String(item.id) === String(variantId));
          if (this.reopenButton) this.reopenButton.hidden = !variant || variant.available;
          if (variant && variant.name) this.applyName(variant.name);
          if (!variant || variant.available) { if (this.dialog.open) this.dialog.close(); if (this.formDialog.open) this.formDialog.close(); return; }
          this.presentNativeForm();
          const ready = Boolean(this.nativeButton());
          this.cta.disabled = !ready;
          if (ready) this.status.textContent = '';
          if (!this.seen.has(variantId)) {
            this.seen.add(variantId);
            this.dialog.showModal();
            this.querySelector('[data-restock-close]').focus();
            clearTimeout(this.noticeTimeout);
            this.noticeTimeout = setTimeout(() => { if (!this.nativeButton()) this.status.textContent = this.status.dataset.unavailable; }, 10000);
          }
          this.syncCursor();
        };
        this.timer = setInterval(this.check, 500);
        this.check();
      }
      applyName(name) {
        document.querySelectorAll('.sndv_bkstk_prod_kwd').forEach(el => { if (el.textContent !== name) el.textContent = name; });
      }
      nativeButton() {
        return Array.from(document.querySelectorAll('#MainContent .sndv_bkstk_notify_btn')).find(button => !button.disabled && button.getClientRects().length && getComputedStyle(button).visibility !== 'hidden');
      }
      restoreCursor() {
        if (!this.cursor?.hasAttribute('data-restock-top-layer')) return;
        if (this.cursor.matches(':popover-open')) this.cursor.hidePopover();
        this.cursor.removeAttribute('data-restock-top-layer');
        this.cursorAttributes.forEach(([name, value]) => {
          if (value == null) this.cursor.removeAttribute(name);
          else this.cursor.setAttribute(name, value);
        });
        this.cursorDialog = null;
      }
      disconnectedCallback() {
        clearInterval(this.timer);
        clearTimeout(this.noticeTimeout);
        document.removeEventListener('click', this.onNativeClick, true);
        this.cursorObserver?.disconnect();
        this.cursorMedia?.removeEventListener('change', this.syncCursor);
        this.cursor?.removeEventListener('load', this.syncCursor);
        this.restoreCursor();
      }
    });
  }
  } catch(e) { console.error(e); }
})();

})();
